import React from 'react'

import { IconProps } from '.'

const Close: React.FC<IconProps> = ({
  size = 20,
  color = '#595959',
  ...rest
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M18 6L6 18M18 18L6 6"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Close
